<template>
  <!--收付款类型-->
  <el-radio-group v-model="paymentTypeCode">
    <el-radio :label="item.dictCode" v-for="item in paymentTypeList" :key="index">{{item.dictName}}</el-radio>
  </el-radio-group>
  <!-------------->
</template>

<script>
  import {getListByTypeCodeAndPCode} from '@/api/dict/dic_manage'

  export default {
    name: "select-paymentType",
    data() {
      return {
        paymentTypeList: [],
        paymentTypeCode: ''
      }
    },
    created() {
      let data = {
        dictTypeCode: 'PAYMENT_TYPE',
        parentCode: -1,
      }
      getListByTypeCodeAndPCode(data).then(res => {
        if (res.code == 1) {
          this.paymentTypeList = res.data
        }
      })
    },
    watch: {
      paymentTypeCode: function (currentVal) {
        this.$emit('paymentTypeInfo', {paymentTypeCode: currentVal})
      }
    }
  }
</script>

<style scoped>

</style>
